<template>
  <div class="-space-y-px bg-white rounded-md">
    <label :for="`${name}-${index}`" v-for="(option, index) in options" :key="option.value" class="relative flex p-4 border first:rounded-t-md last:rounded-b-md" :class="isChecked(option.value) ? 'bg-indigo-50 border-indigo-500 z-10' : 'border-gray-200 hover:bg-gray-50 cursor-pointer'" @click="updateInput(option.value)">
      <div class="flex items-center h-5 cursor-pointer">
        <input :id="`${name}-${index}`" :name="name" type="radio" class="form-radio" :checked="isChecked(option.value)">
      </div>
      <div class="flex flex-col ml-3 cursor-pointer">
        <span class="block text-sm font-medium" :class="isChecked(option.value) ? 'text-indigo-900' : 'text-gray-900'" v-html="option.label"></span>
        <span class="block text-sm" :class="isChecked(option.value) ? 'text-indigo-700' : 'text-gray-500'" v-html="option.description"></span>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: 'RadioStack',

  props: {
    name: {
      type: String,
      default () {
        return (Math.random() * new Date().valueOf()).toString().substr(0, 6)
      }
    },

    value: {
      required: true
    },

    options: {
      type: Array
    }
  },

  methods: {
    isChecked (value) {
      return value == this.value
    },

    updateInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>